// CD: components/search/SearchBar.jsx — suggestions load on the first search interaction.
import { activateLayer, releaseLayer } from './pushe-ui.js';
let loading;
const pending = new WeakSet();
async function enhance(event) {
  const host = event.target.closest?.('pushe-search');
  if (!host || customElements.get('pushe-search')) return;
  const clear = event.type === 'click' && event.target.closest('.pushe-search__clear');
  if (event.type === 'click' && !clear) return;
  if (clear) {
    event.preventDefault();
    const input = host.querySelector('input[name="q"]');
    if (input) { input.value = ''; input.focus(); }
  }
  pending.add(host);
  // Claim synchronously so a search focus request can dismiss an inert parent surface.
  activateLayer(host, () => { pending.delete(host); releaseLayer(host); });
  try {
    loading ??= import('./pushe-search.js');
    await loading;
    if (!pending.delete(host)) return;
    // Retire the provisional closer before the controller claims this same owner.
    releaseLayer(host);
    if (host.isConnected && host.contains(document.activeElement)) {
      host.querySelector('input[name="q"]')?.dispatchEvent(new Event('input', { bubbles: true }));
    }
  } catch {
    loading = undefined;
    pending.delete(host);
    releaseLayer(host);
    // The server-rendered GET form remains usable, including while the module is loading.
  }
}
document.addEventListener('focusin', enhance);
document.addEventListener('input', enhance);
document.addEventListener('click', enhance);
